import React from 'react'
import Header from './Header'
import BodyContribute from './BodyContribute'

const index = ({ active }) => {
    return (
        <div className='max-h-screen'>
            <div className=''>
                <Header active={active} />
            </div>

            <div className='-mt-10 '>
                <BodyContribute />
            </div>
        </div>
    )
}

export default index